// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1BfRE","tabsBox":"styles_tabsBox__3fYdG","createButton":"styles_createButton__2j-4x"};